import { render, staticRenderFns } from "./uploadAllocationKit.vue?vue&type=template&id=2f603fdb&scoped=true"
import script from "./uploadAllocationKit.vue?vue&type=script&lang=js"
export * from "./uploadAllocationKit.vue?vue&type=script&lang=js"
import style0 from "./uploadAllocationKit.vue?vue&type=style&index=0&id=2f603fdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f603fdb",
  null
  
)

export default component.exports